// lib/supabase.ts
import { createBrowserClient } from '@supabase/ssr'
import type { Database } from '@/types/supabase'
import { SupabaseClient } from '@supabase/supabase-js'

type TypedSupabaseClient = SupabaseClient<Database>

let browserSupabase: TypedSupabaseClient | null = null

export function getSupabaseBrowserClient(): TypedSupabaseClient {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

  if (!browserSupabase) {
    if (!supabaseUrl || !supabaseAnonKey) {
      console.error('Supabase-ENV:', {
        supabaseUrl,
        supabaseAnonKey,
      })
      throw new Error('Supabase URL oder Anon Key fehlt in der .env-Datei.')
    }
    
    // Sicherere Konfiguration ohne breaking changes
    browserSupabase = createBrowserClient<Database>(
      supabaseUrl, 
      supabaseAnonKey,
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
        // Wichtig: keine globalen Content-Type Header setzen -> Storage-Uploads funktionieren!
      //  global: {
        //  headers: {
          //  'Accept': 'application/json',
           // 'Content-Type': 'application/json',
         // },
      //  },
        db: {
          schema: 'public',
        },
      }
    ) as any as TypedSupabaseClient
  }
  return browserSupabase
}

// Hilfsfunktion für spezielle Queries mit zusätzlichen Headers
export function getSupabaseClientWithHeaders(
  additionalHeaders?: Record<string, string>
): TypedSupabaseClient {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY
  
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Supabase URL oder Anon Key fehlt in der .env-Datei.')
  }
  
  return createBrowserClient<Database>(
    supabaseUrl,
    supabaseAnonKey,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
      global: {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          ...(additionalHeaders || {}),
        },
      },
      db: {
        schema: 'public',
      },
    }
  ) as any as TypedSupabaseClient
}

// Debug-Funktion für Supabase-Verbindung (nur in Development)
export async function debugSupabaseConnection(): Promise<void> {
  if (process.env.NODE_ENV !== 'development') return
  
  const client = getSupabaseBrowserClient()
  
  console.group('🔍 Supabase Connection Debug')
  
  try {
    // 1. Session prüfen
    const { data: { session }, error: sessionError } = await client.auth.getSession()
    console.log('Auth Session:', session ? '✅ Vorhanden' : '❌ Keine Session')
    if (sessionError) console.error('Session Error:', sessionError)
    
    // 2. User prüfen
    const { data: { user }, error: userError } = await client.auth.getUser()
    console.log('Auth User:', user ? '✅ Vorhanden' : '❌ Kein User')
    if (userError) console.error('User Error:', userError)
    
  } catch (error) {
    console.error('Debug Error:', error)
  }
  
  console.groupEnd()
}
